import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'linebreak' })
@Injectable({ providedIn: 'root' })
export class LinebreakPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        const lines = value.split('\n');
        return lines.map((line, i) => {
            const isCurrentSpecial = /^[\-\#\*\t]/.test(line);
            const prevLine = lines[i - 1];
            const isPrevSpecial = prevLine !== undefined && /^[\-\#\*\t]/.test(prevLine);

            const nextLine = lines[i + 1];
            const isNextSpecial = nextLine !== undefined && /^[\-\#\*\t]/.test(nextLine);

            // Leerzeile zwischen zwei special lines - wichtig für Aufzählungen im Markdown
            if(isNextSpecial && !isCurrentSpecial && line.trim() === '') {
                return '';
            }

            // Zeile ist nicht "special" und nicht die letzte Zeile
            const isSpecial = /^[\-\#\*\t]/.test(line);
            if (!isSpecial && nextLine !== undefined) {
                line = line + '<br>';
            }

            // Wenn vorher special, jetzt nicht: \n voranstellen
            if (isPrevSpecial && !isCurrentSpecial) {
                return '\n' + line;
            }

            return line;
        }).join('\n');
    }
}
